"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InlineFeedbackMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _Icon = require("../../components/Icon/Icon.styles");
var _spaceMixin = require("../spaceMixin");
var _spacingMixin = require("../spacingMixin");
var _typographyMixin = require("../typographyMixin");
var appearanceCSS = function appearanceCSS(props) {
  var appearance = props.appearance;
  return (0, _styledToken.default)({
    iconColor: "status." + appearance + ".foreground",
    errorColor: 'status.error.fontColor'
  }, function (tokens) {
    var styles = [(0, _styledComponents.css)(["> ", ":first-child{color:", ";}"], _Icon.StyledIcon, tokens.iconColor)];
    if (appearance === 'error') {
      styles.push("color: " + tokens.errorColor + ";");
    }
    if (appearance === 'transient') {
      styles.push('font-style: italic;');
    }
    return styles;
  })(props);
};

/** @class InlineFeedbackMixin */
/** @method */
var InlineFeedbackMixin = function InlineFeedbackMixin(props) {
  return (0, _styledToken.default)({
    fontType: 'InlineFeedback.fontType',
    iconSize: 'InlineFeedback.iconSize',
    paddingLeft: 'InlineFeedback.paddingLeft'
  }, function (_ref) {
    var fontType = _ref.fontType,
      iconSize = _ref.iconSize,
      paddingLeft = _ref.paddingLeft;
    return (0, _styledComponents.css)(["margin:0;", " ", " ", " padding-left:", "px;position:relative;> ", ":first-child{position:absolute;top:0;left:0;height:", "px;width:", "px;margin-top:0;}"], (0, _typographyMixin.typographyMixin)(Object.assign({
      fontType: fontType
    }, props)), (0, _spacingMixin.spacingMixin)(props), appearanceCSS(props), (0, _spaceMixin.spaceMixin)(paddingLeft, function (space) {
      return space.value + iconSize;
    })(props), _Icon.StyledIcon, iconSize, iconSize);
  });
};
exports.InlineFeedbackMixin = InlineFeedbackMixin;